import { render, staticRenderFns } from "./Plug.vue?vue&type=template&id=9950cdae&scoped=true&"
import script from "./Plug.vue?vue&type=script&lang=js&"
export * from "./Plug.vue?vue&type=script&lang=js&"
import style0 from "./Plug.vue?vue&type=style&index=0&id=9950cdae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9950cdae",
  null
  
)

export default component.exports